import React, { useState } from 'react'
const TaskLinksBox = ({ openAddLinkPopup, taskLinks, handleRemoveLink }) => {
    const [state, setstate] = useState({
        viewAll: false,
    })
    return (
        <>
            <div className=''>
                <div className='flex items-center gap-3 '>
                    <label className='text-lg font-semibold required'>Task links :</label>
                    <img onClick={openAddLinkPopup} src="/img/add_grey.svg" title='Create Task' alt="save" className="inline-block p-1 bg-gray-200 rounded-sm cursor-pointer size-5" />
                </div>
                <div className="">
                    <div className="flex flex-wrap gap-4 ">
                        {taskLinks.slice(0, state.viewAll ? taskLinks.length : 10)?.map((link, index) => (
                            <span key={link.id + index} className={`flex rounded-md font-semibold items-center p-2 py-1.5  text-sm bg-[#F8FAFB] `}>
                                {link.description}  <img onClick={() => handleRemoveLink(link)} className={`ml-4 cursor-pointer `} src=' /img/roundcross.svg' alt='cross' />
                            </span>
                        ))}
                    </div>
                    {taskLinks.length > 10 ? <span onClick={() => setstate(prev => ({ ...prev, viewAll: !state.viewAll }))} className='float-right px-3 text-sm font-semibold text-right cursor-pointer hover:text-secondary text-secondaryLight hover:underline'>Show {state.viewAll ? 'Less' : 'More'}</span> : null}
                </div>
            </div>
        </>
    )
}

export default TaskLinksBox